/**
 * alert-functions.js
 * アラートモーダル表示用処理
 */

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

/**
 * アラートモーダル表示用処理クラス
 */
export default class AlertDispFunctions {
  /**
   * アラート用定義
   */
  static ALERT_DEF = {
    // アイコン種別
    ICON_TYPE: {
      // 警告
      WARNING: 'warning',
      // 情報
      INFO: 'info',
      // 正常終了
      SUCCESS: 'success',
      // 危険
      DANGER: 'danger',
      // デフォルト
      DEFAULT: 'default',
    },
    // アラート種別
    DISP_TYPE: {
      // トースト
      TOAST: 'toast',
      // 確認アラート (はい/いいえボタン)
      CONFIRM: 'confirm',
      // OK/キャンセル (OK/Cancelボタン)
      OK_CANCEL: 'ok-cancel',
      // マルチボタン
      MULRIPLE: 'multiple',
      // アラート (OKボタンのみ)
      ALERT: 'alert',
    },
    // ボタン押下結果種別
    RESULT_TYPE: {
      // はいボタン押下
      YES: true,
      // いいえボタン押下
      NO: false,
      // OKボタン押下
      OK: true,
      // キャンセルボタン押下
      CANCEL: false,
    },
    // トースト表示最短時間
    TOAST_DISP_MIN_TIME: 3000,
    // トースト表示最長時間
    TOAST_DISP_MAX_TIME: 10000,
    RESULT_TEMPLATE: {
      alertKeyFunction: '',
      alertKeyWord: '',
      alertResultValue: ''
    },
    RESULT_TEMPLATE_KEY_NAME: {
      KEY_FUNCTION: 'alertKeyFunction',
      KEY_WORD: 'alertKeyWord',
      VALUE: 'alertResultValue'
    }
  }

  /**
   * アラート表示データ作成
   * @param {String} title     タイトル
   * @param {String} message   メッセージ
   * @param {String} iconType  アイコンタイプ
   * @param {String} alertType アラートタイプ
   * @param {String} keyFunc   戻り値判定機能名
   * @param {String} keyWord   戻り値判定キーワード
   * @param {Object} multi     マルチリターン定義
   * @param {Number} toastTime トースト表示時間 (秒)
   * @return {Object} アラート表示データ
   */
  static createAlertData(
    title,
    message,
    iconType,
    alertType,
    keyFunc = null,
    keyWord = null,
    multi = {},
    toastTime = 3000
  ) {
    // タイトル
    if (!title) {
      // 未設定の場合はデフォルトタイトル
      title = 'HRモンスター'
    }
    // メッセージ
    if (!message) {
      // 未設定の場合はデフォルトメッセージ
      message = '確認してください。'
    }
    // アイコン種別
    if (!iconType) {
      // 未設定の場合はデフォルトアイコン
      iconType = this.ALERT_DEF.ICON_TYPE.DEFAULT
    }
    // アラート表示種別
    if (!alertType) {
      // 未設定の場合はトースト
      alertType = this.ALERT_DEF.DISP_TYPE.ALERT
    }
    // 戻り値判定機能名
    if (!keyFunc) {
      // 未設定の場合はアラート
      keyFunc = 'alert'
    }
    // 戻り値判定キーワード
    if (!keyWord) {
      // 未設定の場合はアラート
      keyWord = 'alert'
    }
    // マルチリターン定義
    if (alertType === this.ALERT_DEF.DISP_TYPE.MULRIPLE && multi.length <= 0) {
      // 未設定の場合はアラート
      multi = {}
      alertType = this.ALERT_DEF.DISP_TYPE.ALERT
    }
    // トースト表示時間
    toastTime = toastTime * 1000
    if (Number(toastTime) < this.ALERT_DEF.TOAST_DISP_MIN_TIME) {
      // トースト表示最短表示未満の場合は最短時間を設定
      toastTime = this.ALERT_DEF.TOAST_DISP_MIN_TIME
    }
    if (Number(toastTime) > this.ALERT_DEF.TOAST_DISP_MAX_TIME) {
      // トースト表示最長表示を超える場合は最長時間を設定
      toastTime = this.ALERT_DEF.TOAST_DISP_MAX_TIME
    }

    // アラート用データ設定
    const data = {
      // タイトル
      alertTitle: title,
      // メッセージ
      alertMessage: message,
      // アイコン種別
      iconType: iconType,
      // アラート種別
      alertType: alertType,
      // 戻り値判定機能名
      alertKeyFunction: keyFunc,
      // 戻り値判定キーワード
      alertKeyWord: keyWord,
      // マルチリターン定義
      alertMultipleButton: multi,
      // トースト表示時間
      alertToastTime: Number(toastTime),
    }

    // アラート表示用データを返す
    return data
  }
}



// WEBPACK FOOTER //
// ./src/hrm-frontend/modules/functions/alert-functions.js